export default [
    {
        path: '/supplier/search',
        name: 'supplier_search',
        component: () => import('@src/supplier/supplier-search.vue'),
        meta: {
            title: 'Lieferant suchen',
            role: 'ROLE_SHOW_SUPPLIER',
        },
    },
    {
        path: '/supplier/:id',
        name: 'supplier',
        component: () => import('@src/supplier/supplier.vue'),
        props(route) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Lieferant',
            role: 'ROLE_SHOW_SUPPLIER',
        },
    },
];
